export interface PaymentMethodOption {
    code: string;
    logoUrl: string;
    name: string;
    uiPosition: number;
}

export interface PaymentStatusResponse {
    status: 'complete' | 'expired' | 'open',
    customerEmail: string
}

export enum PaymentCompletedPagePaymentType {
    ESTO = "esto",
    STRIPE = "stripe",
    FREE = "free"
}

export interface ConfirmPaymentResponse {
    status: PAYMENT_STATUS;
    productId?: number;
    visibleUntilDate?: Date;
}

export enum PAYMENT_STATUS {
    PAYMENT_SUCCESS,
    PAYMENT_FAIL,
    PAYMENT_UNPAID
}

export interface ConfirmPaymentData {
    paymentToken: string;
}

export interface CheckoutPricesResponse {
    priceAmount: number,
    priceBoost: number,
    textBoost: string,
    discountAmount: number,
    discountText: string,
    total: number,
    discount2Amount?: number,
    discount2Text?: string,
    boostLevel?: number

    discountCodeStatus?: "error" | "success",
    discountCodeResponse?: string,
    discountCodeAmount?: number,
    discountCodeText?: string,
    discountCodeId?: number
}